import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
/**
 *  Hook to transform a catalog into an object to render
 */

const transformCatalogOptions = (catalog, lang) => {
  const capitalize = (str) =>
    str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();

  return catalog.map((item) => ({
    value: item?.path_locales,
    label: capitalize(item?.locales[lang] || item?.label),
  }));
};

export const useTransformedCatalog = (catalog) => {
  const [t] = useTranslation("components");
  const lang = t("hooks.lang");
  const [options, setOptions] = useState(() =>
    transformCatalogOptions(catalog, lang)
  );

  useEffect(() => {
    setOptions(transformCatalogOptions(catalog, lang));
  }, [catalog, lang]);

  return options;
};
